import { DefaultTheme } from 'styled-components'

export const darkTheme: DefaultTheme = {
  // Basic
  mode: 'dark',
  header: '#1D243C',
  surface: '#1D243C',
  background: '#111832',
  supportIcon: '#6A7398',
  progressBar: '#F5F5F5',
  overlay: '#41465B',
  faq: '#C6CDE7',
  reviewGrey: '#737373',

  //Fonts
  darkFont: '#FFFFFF',
  mediumFont: '#C7C7C7',
  lightFont: '#E2E2E2',
  blueFont: '#6986FC',
  placeholder: '#8A8A8A',
  headerFont: '#FFFFFF',

  buttonPrimaryFont: '#FFFFFF',

  buttonSecondaryDefault: '#4065FA',
  buttonSecondaryDisabled: '#969696',
  buttonSecondaryHovered: '#244FF9',
  buttonSecondaryPressed: '#0636F4',

  buttonSecondaryDangerDefault: '#EB001B',
  buttonSecondaryDangerHovered: '#BD0016',
  buttonSecondaryDangerPressed: '#8F0011',

  buttonSecondaryGhostDefault: '#FFFFFF',
  buttonSecondaryGhostDisabled: '#969696',
  buttonSecondaryGhostHovered: '#FFFFFF',
  buttonSecondaryGhostPressed: '#FFFFFF',

  buttonSecondaryDangerGhostDefault: '#EB001B',
  buttonSecondaryDangerGhostHoverd: '#BD0016',
  buttonSecondaryDangerGhostPressed: '#8F0011',

  // Buttons
  primaryDefault: '#4065FA',
  primaryDisabled: '#969696',
  primaryHovered: '#244FF9',
  primaryPressed: '#4059BC',

  primaryDangerDefault: '#EB001B',
  primaryDangerDisabled: '#969696',
  primaryDangerHovered: '#EB001B',
  primaryDangerPressed: '#AD0014',

  buttonSecondaryFont: '#4065FA',

  secondaryDefault: '#FFFFFF',
  secondaryDisabled: '#969696',
  secondaryHovered: '#C6CDE7',
  secondaryPressed: '#AAB8EC',

  buttonSecondaryDangerFont: '#EB001B',

  secondaryDangerDefault: '#FFFFFF',
  secondaryDangerDisabled: '#969696',
  secondaryDangerHovered: '#FBCCD1',
  secondaryDangerPressed: '#F799A4',

  // Inputs
  inputBackground: '#111832',
  inputBorderEmpty: '#8A8A8A',
  inputBorderError: '#FF475A',
  inputBorderActive: '#4065FA',
  inputBorderSaved: '#C7C7C7',

  // Icons
  iconWhite: '#FFFFFF',
  iconLightGrey: '#E2E2E2',
  iconDarkGrey: '#C7C7C7',
  iconBlue: '#6986FC',
  greenDark: '#377D5B',
  greenTransparent: '#5AF2A9',
  redDark: '#881F2C',
  redTransparent: '#FF3F57',

  // Signal
  successGreen: '#5AF2A9',
  successNotificationBackgroundGreen: '#5AF2A9E5',
  errorRed: '#FF475A',
  errorNotificationBackgroundRed: '#FF3F57E5',

  // Logo
  logoBlack: '#FFFFFF',
  logoWhite: '#000000',
  logoPurple: '#6A2FEE',
  logoPink: '#DA1C85',
  logoWhiteTransparent: '#FFFFFF',

  // Report
  reportGrey: '#F0F0F0',

  //Suggestion
  activeSuggestionBackground: '#111832',

  // Dev only
  warningYellow: '#FFC76C',
}
